import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 获取材料账户列表
export const getMaterialAccountList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount?`+params,
        method: 'GET'
    })
};

// 获取材料账户明细
export const getMaterialAccountDetail = (userId, params = {}) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount/${userId}?`+params,
        method: 'GET'
    })
};

// 新增材料账户
export const addMaterialAccount = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount`,
        method: 'POST',
        data: data
    })
};

// 更新材料账户
export const updateMaterialAccount = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount`,
        method: 'PUT',
        data: data
    })
};

// 删除材料账户
export const deleteMaterialAccount = (ids) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount/${ids}`,
        method: 'DELETE'
    })
};
// 获取工程师列表
export const findEngineerList = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount/engineerList`,
        method: 'GET'
    })
};
// 转移分组用户
export const transferGroupUser = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/materialAccount/transferGroupUser`,
        method: 'PUT',
        data: data
    })
};